import { render } from "./error.vue?vue&type=template&id=53bbf76e&ts=true"
import script from "./error.vue?vue&type=script&lang=ts"
export * from "./error.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/error.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53bbf76e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53bbf76e', __exports__)) {
    api.reload('53bbf76e', __exports__)
  }
  
  module.hot.accept("./error.vue?vue&type=template&id=53bbf76e&ts=true", () => {
    api.rerender('53bbf76e', render)
  })

}


export default __exports__